const MOCK = {
  currentUser: { name: 'Usuário', role: 'Perfil', email: '' },
  company: 'Empresa',
  companies: [],
  kpis: {
    processado: { v: 'R$ 0,00', d: 'sem dados', label: 'Processado' },
    pendente: { v: 'R$ 0,00', d: '0 lotes', label: 'Aguardando aprovação' },
    colab: { v: '0', d: 'sem dados', label: 'Colaboradores pagos' },
    diverg: { v: '0', d: 'sem dados', label: 'Divergências abertas' },
  },
  sparkline: [0],
  batches: [],
  divergences: [],
};

const STATUS_MAP = {
  processing: { label: 'PROCESSANDO', kind: 'amber' },
  approval: { label: 'Aguardando Aprovação', kind: 'amber' },
  /** Aprovado no Sienge Pay; aguardando detecção do título emitido no Sienge. */
  sent: { label: 'APROVADO', kind: 'amber' },
  pending: { label: 'PENDENTE', kind: 'red' },
  /** Sienge Pay detectou o título emitido (transmitido ao Sienge). */
  transmitted: { label: 'TRANSMITIDO', kind: 'green' },
  rejected:  { label: 'REJEITADO', kind: 'purple' },
  archived:  { label: 'ARQUIVADO', kind: 'gray' },
  error: { label: 'ERRO API', kind: 'red' },
  draft: { label: 'RASCUNHO', kind: 'gray' },
};

const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'grid' },
  { id: 'approve', label: 'Aprovações', icon: 'shield', badge: 3 },
  { id: 'payments', label: 'Pagamentos', icon: 'history' },
  { id: 'creditors', label: 'Credores', icon: 'users' },
  { id: 'companies', label: 'Empresas', icon: 'building' },
  { id: 'templates', label: 'Modelos', icon: 'file' },
  { id: 'users', label: 'Usuários', icon: 'users' },
];

export { MOCK, STATUS_MAP, NAV };
